module.exports = __webpack_public_path__ + "static/media/GUImage.9bb54ee9.png";